export const translations = {
    et: {
        translation: {
            //warning
            chromiumWarning: "Chromium mootoril põhinevate veebilehitsejatega (nt Chrome, Edge ja Opera) võib esineda GPA kaardirakenduse kuvamisel probleeme - kaardipilti ei kuvata täielikuna. Probleem on Chromium põhiste veebilehitsejate tarkvaras. Võimalusel palume kasutada näiteks Firefox veebilehitsejat.",
            //header
            title: "Geodeetiliste punktide andmekogu",
            searchByName: "Otsi nime järgi",
            searchByGPAID: "Otsi GPA ID järgi",
            searchByCodeNo: "Otsi koodnumbri järgi",
            searchByCoords: "Otsi koordinaatide järgi",
            searchBySettlementUnits: "Otsi asustusüksuse järgi",
            //footer
            organization: "Maa- ja Ruumiamet",
            //calculator dropdown
            calculatorMenuTitle: "Kalkulaatorid",
            geoLESTMenu: "Geodeetilised koordinaadid EUREF-EST97 - Tasapinnalised ristkoordinaadid L-EST97",
            globalMenu: "Globaalne kalkulaator",
            helmMenu: "Kohalikud kalkulaatorid - Tasapinnalised ristkoordinaadid L-EST97",
            geoidMenu: "EUREF-EST97 ellipsoidaalsed kõrgused - normaalkõrgused EH2000",
            ymudelMenu: "BK77 ja EH2000 kõrguste ülemineku kalkulaator",
            crdMudelMenu: "Eesti-Läti piiriala koordinaatide ülemineku kalkulaator",
            valgaCrdMudelMenu: "Valga-Valka koordinaatide ülemineku kalkulaator",
            hmudelMenu: "Eesti-Läti piiriala kõrguste ülemineku kalkulaator",
            //index page
            generalInfo1: "Geodeetiliste märkide abil saab looduses täpselt määrata mistahes objekti asukohta. Märgid on abiks topograafiliste kaartide koostamisel ja uuendamisel, ehituseelsete tööde tegemisel alates projektide koostamisest kuni ehitiste märkimiseni looduses, kinnistu piiride täpsustamisel, kaevandusalade kaardistamisel jne. Geodeetilisi märke hakati Eestis rajama juba enam kui poolteist sajandit tagasi. Neist vanim kasutuses olev märk on paigaldatud 1891. aastal ja asub Kuremäe kloostri juures.",
            generalInfo2: "Geodeetiliste punktide andmekogusse (GPA) koondatud geodeetiliste märkide asukohainfo tugineb Eesti geodeetilisel süsteemil",
            generalInfo3: "Geodeetilise märgi kaitsevöönd on geodeetilist märki ümbritsev ala, kus geodeetilise märgi kaitse ja kasutamise vajadusest tulenevalt kitsendatakse inimtegevust. Geodeetilise märgi kaitsevööndi ulatus on kehtestatud Keskkonnaministri 28.06.2013.a määrusega nr 50 \"Geodeetiliste tööde tegemise ja geodeetilise märgi tähistamise kord, geodeetilise märgi kaitsevööndi ulatus ning kaitsevööndis tegutsemiseks loa taotlemise kord\" § 17.",
            generalInfo4: "\"Ruumiandmete seadus\" § 26 lõige 1 sätestab, et geodeetilise märgi kaitsevööndis on ilma geodeetilise märgi omaniku loata keelatud igasugune tegevus, mis võib kahjustada geodeetilist märki ja selle tähistust, mh löökmehhanismidega töötamine, pinnase tihendamine või tasandamine, transpordivahenditele ja mehhanismidele läbisõidukohtade rajamine ning künni- või mullatööde tegemine. Geodeetilise märgi kaitsevööndis tegutsemiseks peab taotlema loa geodeetilise märgi omanikult. Kahjustatud geodeetilistest märkidest tuleb teavitada Maa- ja Ruumiametit (kui tegemist on riikliku geodeetilise võrgu märgiga) või kohalikku omavalitsust (kui tegemist on kohaliku geodeetilise võrgu märgiga).",
            generalInfoList: "Geodeetiline süsteem tagab ühtses koordinaat-, kõrgus- ja gravimeetrilises süsteemis reaalmaailma nähtuste asukoha ja raskuskiirenduse määramise ning nende järjepideva monitooringu. Geodeetiline süsteem on ruumiandmete infrastruktuuri alus, mis kindlustab andmekogude pidamist. Geodeetiline süsteem koosneb",
            generalInfoListItem1: "geodeetilisest referentssüsteemist;",
            generalInfoListItem2: "tasapinnaliste ristkoordinaatide süsteemist;",
            generalInfoListItem3: "kõrgussüsteemist;",
            generalInfoListItem4: "gravimeetrilisest süsteemist;",
            generalInfoListItem5: "nimetatud süsteemidele vastavatest geodeetilistest võrkudest.",
            generalInfo5: "Geodeetilise süsteemi kasutamine on kohustuslik teabevaldaja andmekogu pidamisel ja ruumiandmeteenuse osutamisel ja geodeetiliste andmete töötlemisel, kui neid andmeid kasutatakse teabevaldaja andmekogus.",
            generalInfoContacts1: "Kontaktisikute info:",
            generalInfoContacts2: "Andmekogu sisu haldus: Arvi Taru, arvi.taru@maaruum.ee ja Liisi Kaleva, liisi.kaleva@maaruum.ee",
            generalInfoContacts3: "Andmekogu tehniline haldus: KEMIT, help@kemit.ee",
            //search forms
            nameSearchPopoverText: "Punkti otsimine nime või selle osa järgi.",
            nameSearchExactMatch: "Leia täpne vaste",
            idSearchPopoverText: "Punkti otsimine Geodeetiliste Punktide Andmekogu numbri (GPA ID) järgi.",
            codeSearchPopoverText1: "Otsimine geodeetilise punkti unikaalse koodnumbri järgi.",
            codeSearchPopoverText2: "Kõik väljad ei pea täidetud olema.",
            codeSearchPopoverText3: "Sisestada saab ainult arve.",
            codeSearchCodeNumberText: "Koodnumber",
            coordinatesSearchPopoverText1: "Otsimine geodeetilise punkti koordinaatide järgi.",
            coordinatesSearchPopoverText2: "Leitakse sisestatud raadiuses kõik koordinaatide ümbruses olevad punktid.",
            coordinatesSearchCoordinatesText: "Koordinaadid",
            coordinatesSearchRadiusInMeters: "raadius meetrites",
            settlementSearchPopoverText: "Punkti otsimine asustusüksuse järgi.",
            //results
            resultId: "GPA ID",
            resultPointNumber: "Punkti number",
            resultName: "Nimi",
            resultCode: "Koodnumber",
            resultPlaneTrCoords: "Tasapinnalised ristkoordinaadid",
            resultGeodeticCoords: "Geodeetilised koordinaadid",
            resultNormHeight: "Normaalkõrgus H",
            resultEllipsoidHeight: "Ellipsoidaalne kõrgus h",
            resultGrAcceleration: "Raskuskiirendus g",
            resultNetwork: "Võrku kuuluvus",
            resultSettlemUnit: "Asustusjaotus",
            resultLocationDescription: "Asukohakirjeldus",
            resultCondition: "Seisukord",
            resultComments: "Märkused",
            resultGNSSCompatibility: "GNSS sobivus",
            resultMarkerType: "Märgi tüüp",
            resultProtectionArea: "Kaitsevöönd",
            resultSearchByName: "Otsiti nime",
            resultSearchByCode: "Otsiti koodi",
            resultSearchBySettlementUnit: "Otsiti asustusüksuse järgi",
            resultSearchByCoords: "Otsiti koordinaatide <0>{{xCoord}}, {{yCoord}}</0> järgi <0>{{radius}}</0>m raadiuses.",
            results: "Tulemusi",
            resultsLoadingAtOnce: "Laadin korraga",
            downloadSearchResult: "Laadi otsingu tulemus CSV failina oma arvutisse",
            resultLoadingMore: "Laadin juurde...",
            resultLoadMore: "Laadi juurde",
            resultNoFilter: "Filter puudub",
            showAllResults: "Näita kõik tulemused",
            //single point details
            singleNoPointError: "Sellise ID-ga punkti ei leitud",
            singleQueryError: "Probleem päringu tegemisel. Veakood: {{errorCode}}",
            singleTabInfoTitle: "Info",
            singleTabMapTitle: "Kaart",
            singleTabCameraTitle: "Kaldkaamera",
            singleJobName: "Töö nimi",
            singleArchiveNumber: "Arhiivi nr",
            singleTransformResult: "arvutatud transformeerimise teel",
            singleBK77ToEH2000TransitionalModelResult: "arvutatud BK77->EH2000 üleminekumudelist",
            singleGeoidModelResult: "arvutatud geoidi mudeli EST-GEOID2017 kaudu",
            singleNormalField: "Normaalväli (GRS80)",
            singleBouguerAnomaly: "Bouguer anomaalia",
            singleOpenAirAnomaly: "Vabaõhuanomaalia",
            singleFindPointsInRadiusButtonLabel: "Leia punktid 1000m raadiuses",
            singleDownloadDataAsTextFile: "Laadi info alla tekstifailina",
            //calculators
            usingCalculators: "Geodeesia kalkulaatorite kasutamisest",
            calculateButtonLabel: "Arvuta",
            searchButtonLabel: "Otsi",
            tabSingleCoordTitle: "Üksikpunkti koordinaatide arvutus",
            tabMultipleCoordsTitle: "Failist üles laetud koordinaatide arvutus",
            tabTextareaCoordsTitle: "Vormi kaudu saadetud koordinaatide arvutus",
            coordsInDec: "* B ja L kümnendkraadides",
            answer: "Vastus",
            or: "või",
            name: "nimi",
            loadingFileSuccess: "Faili laadimine õnnestus.",
            loadingFileFailed: "Faili laadimine ebaõnnestus.",
            downloadResult: "Laadi tulemus alla",
            requestError: "Viga päringu tegemisel",
            inputError: "Viga sisendis",
            onlyNumbersError: "Sisestada saab ainult arve",
            crdMudelTabTitle: "L-EST97 ja LKS-92 TM tasapinnaliste ristkoordinaatide ülemineku kalkulaator",
            valgaCrdMudelTabTitle: "L-EST97 ja LKS-92 TM tasapinnaliste ristkoordinaatide ülemineku kalkulaator kaksiklinnas Valga-Valka",
            interregProject: "Kalkulaator on loodud Interreg Eesti-Läti projekti „Geodeetiliste süsteemide harmoniseerimine Eesti-Läti piirialal“ (GeoRefAct) raames.",
            outsideModelArea: "Väljaspool mudeli andmeala. Kasutage Eestis EH2000 ja Lätis LAS-2000,5 kõrgusi.",
            outsideCrdModelArea: "Väljaspool mudeli andmeala.",
            directionLESTToLKS: "Tasapinnalised ristkoordinaadid L-EST97 -> Tasapinnalised ristkoordinaadid LKS-92 TM",
            directionLKSToLEST: "Tasapinnalised ristkoordinaadid LKS-92 TM -> Tasapinnalised ristkoordinaadid L-EST97",
            inputFileThreeColumns: "Sisendfailis kolm veergu.",
            threeColumnCSVFileDescription: "CSV failis esimene rida on veerupäise rida, milles veerud peavad olema nimetatud järgmiselt: nimi,x,y",
            threeColumntextFileDescription: "Tekstifail kujul: veerg1 veerg2 veerg3",
            threeColumnTextAreaDescription: "Sisendiks kolm veergu, eraldajateks tühimärgid(tühik, tab): veerg1 veerg2 veerg3",
            dataDescription: "Andmed mõlema failitüübi veergudes on kujul:",
            inputInColumns: "Sisend veergudena kujul",
            gaussTabTitle: "Globaalne kalkulaator",
            inputFileFourColumns: "Sisendfailis neli veergu.",
            fourColumnCSVFileDescription: "CSV failis esimene rida on veerupäise rida, milles veerud peavad olema nimetatud järgmiselt: nimi,x,y,h",
            fourColumntextFileDescription: "Tekstifail kujul: veerg1 veerg2 veerg3 veerg4",
            fourColumnTextAreaDescription: "Sisendiks neli veergu, eraldajateks tühimärgid(tühik, tab): veerg1 veerg2 veerg3 veerg4",
            dataFieldNameText: "nimi",
            inputXCoordinate: "sisendkoordinaatsüsteemi x-koordinaat",
            inputYCoordinate: "sisendkoordinaatsüsteemi y-koordinaat",
            inputHeight: "sisendkoordinaatsüsteemi kõrgus",
            coordsInForm: "Geodeetilised koordinaadid kujul DDD.MMSSSSSSSS",
            geoidTabTitle: "EUREF-EST97 ellipsoidaalsed kõrgused - normaalkõrgused EH2000.",
            geoidCreators: "A. Ellmann, S. Märdla, T. Oja: Eesti geoidi mudel EST-GEOID2017. Tallinna Tehnikaülikool 2017.",
            disclaimerFirst: "EST-GEOID2017 geoidi mudeli (edaspidi teose) kasutamine toimub lõppkasutaja vastutusel.",
            disclaimerSecond: "Teose võimalikest ebatäpsustest tuleneva võimaliku varalise kahju eest Maa- ja Ruumiamet vastutust ei kanna.",
            disclaimerThird: "Teose lubamatu ega oskamatu kasutamise eest lõppkasutaja poolt ega lõppkasutaja vigade eest teose kasutamisel Maa- ja Ruumiamet ei vastuta.",
            directionEllipsoidalToNormal: "Ellipsoidaalne kõrgus EUREF-EST97 -> Normaalkõrgus EH2000",
            directionNormalToEllipsoidal: "Normaalkõrgus EH2000 -> Ellipsoidaalne kõrgus EUREF-EST97",
            geoLestTabTitle: "Geodeetilised koordinaadid EUREF-EST97 - Tasapinnalised ristkoordinaadid L-EST97",
            directionGeoToLEST: "Geodeetilised koordinaadid EUREF-EST97 -> Tasapinnalised ristkoordinaadid L-EST97",
            directionLESTToGeo: "Tasapinnalised ristkoordinaadid L-EST97 -> Geodeetilised koordinaadid EUREF-EST97",
            helmTabTitle: "Kohalikud koordinaadid - Tasapinnalised ristkoordinaadid L-EST97",
            directionLocalToLEST: "Kohalikud koordinaadid -> Tasapinnalised ristkoordinaadid L-EST97",
            directionLESTToLocal: "Tasapinnalised ristkoordinaadid L-EST97 -> Kohalikud koordinaadid",
            hmudelTabTitle: "EH2000 ja LAS-2000,5 kõrguste ülemineku kalkulaator",
            directionEH2000ToLAS20005: "EH2000 kõrgus -> LAS-2000,5 kõrgus",
            directionLAS20005ToEH2000: "LAS-2000,5 kõrgus -> EH2000 kõrgus",
            ymudelTabTitle: "BK77 ja EH2000 kõrguste kõrguste ülemineku kalkulaator",
            gaussFormOption1: "1963.a. 0. tsoon",
            gaussFormOption2: "1942.a. telgmeridiaan 24",
            gaussFormOption3: "1963.a. 1. tsoon",
            gaussFormOption4: "1963.a. 2. tsoon",
            gaussFormOption5: "1942.a. 4. tsoon",
            gaussFormOption6: "1942.a. 5. tsoon",
            gaussFormOption7: "Baaskaart",
            gaussFormOption8: "EUREF-EST97, WGS-84 geodeetiline",
            gaussFormOption10: "Pulkovo80 geodeetiline",
            //image modal
            modalPanorama: "Panoraam",
            modalBlueprint: "Abriss",
            modalMarkerType: "Märgi tüüp",
            modalPictures: "Pildid",
            modalLocale: "et-EE",
            //filter
            klassXy: "x, y:",
            klassKorgus: "H:",
            klassGr: "g:",
            skoodTxt: "Seisukord:",
        },
    },
    en: {
        translation: {
            //warning
            chromiumWarning: "Web browsers based on the Chromium engine (e.g. Chrome, Edge and Opera) may have problems displaying the GPA map application - the map image is not displayed in full. The problem is in the software of Chromium-based web browsers. If possible, please use the Firefox web browser, for example.",
            //header
            title: "Geodetic Point Database",
            searchByName: "Search by point name",
            searchByGPAID: "Search by GPD ID",
            searchByCodeNo: "Search by code number",
            searchByCoords: "Search by coordinates",
            searchBySettlementUnits: "Search by administrative unit",
            //footer
            organization: "Estonian Land and Spatial Development Board",
            //calculator dropdown
            calculatorMenuTitle: "Calculators",
            geoLESTMenu: "Geodetic coordinates EUREF-EST97 - Planar coordinates L-EST97",
            globalMenu: "Global calculator",
            helmMenu: "Local calculators - Planar coordinates L-EST97",
            geoidMenu: "EUREF-EST97 Ellipsoidal heights - Normal heights EH2000",
            ymudelMenu: "BK77 and EH2000 height conversion calculator",
            crdMudelMenu: "Estonian-Latvian border region coordinates transition calculator",
            valgaCrdMudelMenu: "Valga-Valka coordinates transition calculator",
            hmudelMenu: "Estonian-Latvian border region heights transition calculator",
            //index page
            generalInfo1: "With the help of geodetic marks the exact location of any object can be determined in nature. The marks are helpful in preparing and updating topographic maps, performing pre-construction work, from drafting up projects to marking buildings in nature, specifying property boundaries, mapping mining areas, etc. Establishment of geodetic marks in Estonia started more than a century and a half ago. The oldest geodetic mark in use was installed in 1891 and is located near the Kuremäe monastery.",
            generalInfo2: "The location information of geodetic marks collected in the Geodetic Point Database (GPD) is based on the Estonian geodetic system.",
            generalInfo3: "The protected zone of a geodetic mark is the area surrounding the geodetic mark where human activity is restricted due to the necessity to protect and use the geodetic mark. The extent of the protection zone of the geodetic mark is established by the Regulation of the Minister of the Environment of 28.06.2013 No. 50 \"The procedure of geodetic works and marking of geodetic marks, the extent of protected zones and the procedure of applying for permission for activities in protected zones\" § 17.",
            generalInfo4: "\"Spatial Data Act\" § 26 subsection 1 states that in the protection zone of a geodetic mark any activity that may damage the geodetic mark and its marking is prohibited without the permission of the owner of the geodetic mark. This includes operating impact mechanisms, compressing or levelling of ground, constructing passageways for means of transportation and mechanisms, ploughing and performing earthwork. To conduct activities in the protected zone of a geodetic mark a permit must be applied from the owner of the geodetic mark. Damaged geodetic marks must be reported to the Estonian Land and Spatial Development Board (if the geodetic mark belongs to a national geodetic network) or the local government (if the geodetic mark belongs to a local geodetic network).",
            generalInfoList: "The geodetic system guarantees the determination of the location of real-world phenomena, their gravity values and continuous monitoring in a uniform coordinate, height and gravimetric system. The geodetic system serves as a basis for the spatial data infrastructure which supports the maintenance of databases. The geodetic system consists of",
            generalInfoListItem1: "geodetic reference system;",
            generalInfoListItem2: "planar coordinate system;",
            generalInfoListItem3: "height system;",
            generalInfoListItem4: "gravimetric system;",
            generalInfoListItem5: "and geodetic networks corresponding to given systems.",
            generalInfo5: "Use of the geodetic system is mandatory for information holders in the maintenance of a database, in the provision of spatial data services and upon processing of geodetic data if the data are used in the database of the information holder.",
            generalInfoContacts1: "Contact persons information:",
            generalInfoContacts2: "Content management of the database: Arvi Taru, arvi.taru@maaruum.ee and Liisi Kaleva, liisi.kaleva@maaruum.ee",
            generalInfoContacts3: "Technical management of the database: KEMIT, help@kemit.ee",
            //search forms
            nameSearchPopoverText: "Point search by point name or part of point name.",
            nameSearchExactMatch: "Find an exact match",
            idSearchPopoverText: "Point search by Geodetic Point Database (GPD ID) number.",
            codeSearchPopoverText1: "Search by geodetic point unique code number.",
            codeSearchPopoverText2: "Not all fields need to be filled.",
            codeSearchPopoverText3: "Only numbers can be inserted.",
            codeSearchCodeNumberText: "Code number",
            coordinatesSearchPopoverText1: "Search by geodetic point coordinates.",
            coordinatesSearchPopoverText2: "All points within the entered radius around the coordinates are found.",
            coordinatesSearchCoordinatesText: "Coordinates",
            coordinatesSearchRadiusInMeters: "Radius in meters",
            settlementSearchPopoverText: "Point search by administrative unit.",
            //results
            resultId: "GPD ID",
            resultPointNumber: "Point number",
            resultName: "Name",
            resultCode: "Code number",
            resultPlaneTrCoords: "Planar coordinates",
            resultGeodeticCoords: "Geodetic coordinates",
            resultNormHeight: "Normal height H",
            resultEllipsoidHeight: "Ellipsoidal height h",
            resultGrAcceleration: "Gravity value g",
            resultNetwork: "Geodetic network",
            resultSettlemUnit: "Administrative distribution",
            resultLocationDescription: "Location description",
            resultCondition: "Condition",
            resultComments: "Notes",
            resultGNSSCompatibility: "GNSS suitability",
            resultMarkerType: "Benchmark type",
            resultProtectionArea: "Protected zone",
            resultSearchByName: "Searched by name",
            resultSearchByCode: "Searched by code",
            resultSearchBySettlementUnit: "Searched by administrative unit",
            resultSearchByCoords: "Searched by coordinates <0>{{xCoord}}, {{yCoord}}</0> within a radius of <0>{{radius}}</0> m.",
            results: "Results",
            resultsLoadingAtOnce: "Load at once",
            downloadSearchResult: "Download the search result as CSV file to your computer",
            resultLoadingMore: "Loading more...",
            resultLoadMore: "Load more",
            resultNoFilter: "Filter missing",
            showAllResults: "Show all results",
            //single point details
            singleNoPointError: " No point with this ID was found",
            singleQueryError: "Problem with the request. Error code: {{errorCode}}",
            singleTabInfoTitle: "Information",
            singleTabMapTitle: "Map",
            singleTabCameraTitle: "Oblique camera",
            singleJobName: "Report number",
            singleArchiveNumber: "Archive number",
            singleTransformResult: "Computed by transformation",
            singleBK77ToEH2000TransitionalModelResult: "Computed with BK77->EH2000 transition model",
            singleGeoidModelResult: "Computed with geoid model EST-GEOID2017",
            singleNormalField: "Normal gravity field (GRS80)",
            singleBouguerAnomaly: "Bouguer anomaly",
            singleOpenAirAnomaly: "Free-air anomaly",
            singleFindPointsInRadiusButtonLabel: "Find points within a 1000 m radius",
            singleDownloadDataAsTextFile: "Download information as text file",
            //calculators
            usingCalculators: "Using geodesy calculators",
            calculateButtonLabel: "Compute",
            searchButtonLabel: "Search",
            tabSingleCoordTitle: "Coordinate computation for a single point",
            tabMultipleCoordsTitle: "Coordinate computation using file",
            tabTextareaCoordsTitle: "Coordinate computation using form",
            coordsInDec: "* B and L in decimal degrees",
            answer: "Answer",
            or: "or",
            name: "name",
            loadingFileSuccess: "File upload successful.",
            loadingFileFailed: "File upload unsuccessful.",
            downloadResult: "Download results",
            requestError: "Error in inquiry",
            inputError: "Error in input",
            onlyNumbersError: "Only numbers can be inserted",
            crdMudelTabTitle: "L-EST97 and LKS-92 TM planar coordinate calculator",
            valgaCrdMudelTabTitle: "L-EST97 and LKS-92 TM planar coordinate calculator in twin-city Valga-Valka",
            interregProject: "The calculator was created within the framework of the Interreg Estonia-Latvia project „Harmonization of Geodetic Systems in the Estonia-Latvia Border Area“ (GeoRefAct).",
            outsideModelArea: "Outside model area. Please use EH2000 heights in Estonia and LAS-2000,5 heights in Latvia.",
            outsideCrdModelArea: "Outside model area.",
            directionLESTToLKS: "Planar coordinates L-EST97 -> Planar coordinates LKS-92 TM",
            directionLKSToLEST: "Planar coordinates LKS-92 TM -> Planar coordinates L-EST97",
            inputFileThreeColumns: "Input file has three columns.",
            threeColumnCSVFileDescription: "In the CSV file, the first line is the column header line, in which the columns must be named: nimi,x,y",
            threeColumntextFileDescription: "Text-file: column1 column2 column3",
            threeColumnTextAreaDescription: "Input in three columns, whitespace characters(space, tab) as separator: column1 column2 column3",
            dataDescription: "Data in the columns of both file types is in the form:",
            inputInColumns: "Input as columns",
            gaussTabTitle: "Global calculator",
            inputFileFourColumns: "Input file has four columns.",
            fourColumnCSVFileDescription: "In the CSV file, the first line is the column header line, in which the columns must be named: nimi,x,y,h",
            fourColumntextFileDescription: "Text-file: column1 column2 column3 column4",
            fourColumnTextAreaDescription: "Input in four columns, whitespace characters(space, tab) as separator: column1 column2 column3 column4",
            dataFieldNameText: "name",
            inputXCoordinate: "Northing in input coordinate system",
            inputYCoordinate: "Easting in input coordinate system",
            inputHeight: "Height in input coordinate system",
            coordsInForm: "Geodetic coordinates in form of DDD.MMSSSSSSSS",
            geoidTabTitle: "EUREF-EST97 ellipsoidal heights - normal heights EH2000.",
            geoidCreators: "A. Ellmann, S. Märdla, T. Oja: Estonian Geoid model EST-GEOID2017. Tallinn University of Technology 2017.",
            disclaimerFirst: "The use of the EST-GEOID2017 geoid model is at the responsibility of the user.",
            disclaimerSecond: "The Land and Spatial Development Board shall not be held liable for any errors caused by the inaccuracy of the model for any loss of profits, or any incidental or consequential loss or damage.",
            disclaimerThird: "The Land and Spatial Development Board shall not be held liable for unauthorized or unskilful use of the model, or for mistakes made by the user when using the model.",
            directionEllipsoidalToNormal: "Ellipsoidal height EUREF-EST97 -> Normal height EH2000",
            directionNormalToEllipsoidal: "Normal height EH2000 -> Ellipsoidal height EUREF-EST97",
            geoLestTabTitle: "Geodetic coordinates EUREF-EST97 - Planar coordinates L-EST97",
            directionGeoToLEST: "Geodetic coordinates EUREF-EST97 -> Planar coordinates L-EST97",
            directionLESTToGeo: "Planar coordinates L-EST97 -> Geodetic coordinates EUREF-EST97",
            helmTabTitle: "Local coordinates - Planar coordinates L-EST97",
            directionLocalToLEST: "Local coordinates -> Planar coordinates L-EST97",
            directionLESTToLocal: "Planar coordinates L-EST97 -> Local coordinates",
            hmudelTabTitle: "EH2000 and LAS-2000,5 height transition calculator",
            directionEH2000ToLAS20005: "EH2000 height -> LAS-2000,5 height",
            directionLAS20005ToEH2000: "LAS-2000,5 height -> EH2000 height",
            ymudelTabTitle: "BK77 and EH2000 height transition calculator",
            gaussFormOption1: "1963 0-zone",
            gaussFormOption2: "1942 central meridian 24",
            gaussFormOption3: "1963 1-zone",
            gaussFormOption4: "1963 2-zone",
            gaussFormOption5: "1942 4-zone",
            gaussFormOption6: "1942 5-zone",
            gaussFormOption7: "Base map",
            gaussFormOption8: "EUREF-EST97, WGS-84 geodetic",
            gaussFormOption10: "Pulkovo80 geodetic",
            //image modal
            modalPanorama: "Panorama",
            modalBlueprint: "Sketch",
            modalMarkerType: "Benchmark type",
            modalPictures: "Photos",
            modalLocale: "en-GB",
            //filter
            klassXy: "x, y:",
            klassKorgus: "H:",
            klassGr: "g:",
            skoodTxt: "Condition:",
        },
    },
};
  